import s from './Bewertung.module.scss'

/** Der Ton zu einer Bewertung: das Vorzeichen, nicht der Betrag. */
export function bewertungsTon(wert: number): 'positiv' | 'negativ' | 'neutral' {
  return wert > 0 ? 'positiv' : wert < 0 ? 'negativ' : 'neutral'
}

/** „+2", „−1", „0" — mit Vorzeichen, damit eine Richtung dasteht, keine Menge. */
export function bewertungsText(wert: number): string {
  return wert > 0 ? `+${wert}` : wert < 0 ? `−${Math.abs(wert)}` : '0'
}

/**
 * Die Bewertung einer Meldung als Kästchen: weiße Ziffer auf der Farbe des
 * Vorzeichens. Sieben Stufen von −3 bis +3; die Farbe trägt die Richtung, die
 * Ziffer die Stärke.
 */
export function Bewertung({ wert, gross }: {
  wert: number
  /** Im Detail größer als in der Zeile. */
  gross?: boolean
}) {
  return (
    <span className={`${s.kasten} ${gross ? s.gross : ''}`}
          data-ton={bewertungsTon(wert)}
          title={`Bewertung ${bewertungsText(wert)} auf einer Skala von −3 bis +3`}>
      {bewertungsText(wert)}
    </span>
  )
}
